import * as React from "react";
import { connect } from "react-redux";
import moment from "moment";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import { Button } from "react-bootstrap";
import { GetURIByParts } from "../../../services/Utils/StringUtils";
import "react-dates/lib/css/_datepicker.css";
import "./assets/KeywordQueue.scss";
import { DateRangePicker } from "react-dates";
import {
  assignAndOpen,
  loadImage,
  openReportById,
  unAssign,
  deleteReport,
  unDeleteReport,
  searchKeywordsPaged,
  setLoadingQueueItems,
  getKeywordQueueItems
} from "./redux-objects/actions";
import {
  IAuditLogBase,
  IExportColumnMap,
  PagedResultsRequest
} from "../../../common/sharedTypes";
import { UserInfo } from "../../Login/common/defaults";
import * as urls from "../../shared/urls";
import CommentModal from "../../CommentModal/CommentModal";
import { toast } from "react-toastify";
import {
  ElasticIndices,
  LogCategoryEnum,
  LoggingLevel
} from "../../../services/Enums/shared";
import { createManagementAuditLog } from "../Management/redux-objects/actions";
import Api from "../../../services/Api";
import { ApiResponse } from "apisauce";
import { QueueStartDate } from "../common";
import {
  KeywordQueueItem,
  SearchKeywordQueuePagedRequest
} from "./business-objects/common";
import _ from "lodash";
import PagedDatatable from "../../PagedDataTable";
import { TableColumn } from "react-data-table-component/dist/DataTable/types";
import LocalStorageUtils from "../common/LocalStorageUtils";
export interface IKeywordQueuePagedActionProps {
  searchKeywordsPaged?: (
    url: string,
    request: SearchKeywordQueuePagedRequest
  ) => void;
  setLoadingQueueItems?: (value: boolean) => void;
  openReportById?: (
    workflowItemStepId: number,
    callback?: () => void
  ) => Promise<void>;
  deleteReport?: (url: string, workflowItemStepId: number, comment: string) => Promise<void>;
  unDeleteReport?: (url: string, workflowItemStepId: number) => Promise<void>;
  assignAndOpen?: (
    url: string,
    stepItemId: number,
    assignToId: number
  ) => Promise<void>;
  unAssign?: (url: string, stepItem: any) => Promise<void>;
  loadImage?: (documentId: string, forceNewWindow: boolean) => Promise<void>;
}
interface IKeywordQueuePagedStateProps {
  keywordQueueItems: KeywordQueueItem[];
  totalKeywordQueueItems: number;
  loadingQueueItems: boolean;
  webServiceURL: string;
  isProcessing: boolean;
  history: any;
  currentUser: UserInfo;
}

interface IKeywordQueuePagedControllerStateProps {
  data: any[];
  showCommentModal: boolean;
  comment: string;
  pendingAction: string;
  reportIdValue: number;
}

interface IKeywordQueuePagedPropsFromDispatch {
  createManagementAuditLog: (managementLog: IAuditLogBase, value: any) => void;
}

interface IKeywordQueuePagedProps
  extends IKeywordQueuePagedActionProps,
  IKeywordQueuePagedStateProps,
  IKeywordQueuePagedPropsFromDispatch,
  IKeywordQueuePagedControllerStateProps { }

enum ModalMode {
  None,
  New,
  Editing
}

enum ServiceEndPoints {
  SearchPaperReportKeywordQueue = "SearchPaperReportKeywordQueue",
  AssignWorkflowItemStep = "AssignWorkflowItemStep",
  UnAssignWorkflowItemStep = "UnAssignWorkflowItemStep"
}

const initialState = {
  data: [],
  userOnly: false,
  assignedOnly: false,
  unassignedOnly: false,
  startDate: moment(QueueStartDate),
  endDate: moment(),
  focusedInput: null,
  showModal: false,
  modalStatus: ModalMode.None,
  openingReport: false,
  showCommentModal: false,
  comment: "",
  reportIdValue: 0,
  onUpdateActiveStatus: false,
  pendingAction: "",
  deleteStatus: null,
  undeleteStatus: null,
  includeDeleted: false,
  includeNewDriverReports: false,
  pagingCriteria: {
    itemsPerPage: 10,
    pageNumber: 1,
    searchCriteria: null,
    orderByField: "OnBasePriorityNumber",
    orderDescending: false
  }
};
type KeywordQueuePagedState = Readonly<typeof initialState>;

class KeywordQueuePaged extends React.Component<
  IKeywordQueuePagedProps,
  KeywordQueuePagedState
> {
  public constructor(props: IKeywordQueuePagedProps) {
    super(props);
    this.state = initialState;
  }

  private rowData: any;
  private id: number;
  private pendingAction: string;
  private reportIdValue: number;

  // TODO: Refactor to configuration file
  private workflowController: string = "Workflow";
  private includeNewDriverReportsVariable: string =
    "KeywordsIncludeNewDriverReportsCheckbox";
  private includeDeletedReportsVariable: string =
    "KeywordsIncludeDeletedReportsCheckbox";
  private assignedOnlyVariable: string = "KeywordsAssignedOnlyCheckbox";
  private userOnlyVariable: string = "KeywordsUserOnlyCheckbox";
  private startDateVariable: string = "KeywordsStartDate";
  private endDateVariable: string = "KeywordsEndDate";
  private unassignedOnlyVariable: string = "KeywordsUnassignedOnlyCheckbox";

  componentDidMount() {
    this.populateKeywords();
  }

  closeModal = () => {
    this.toggleScrollLock();
    this.setState({
      modalStatus: ModalMode.None,
      showModal: false
    });
  };

  toggleScrollLock = () => {
    document.querySelector("html").classList.toggle("scroll-lock");
  };

  handleAssignedOnlyCheck(isChecked: any) {
    LocalStorageUtils.setLocalStorageItem(this.assignedOnlyVariable, isChecked);
    this.setState({ assignedOnly: isChecked }, () => {
      this.populateKeywords();
    });
  }

  handleUnassignedOnlyCheck(isChecked: any) {
    LocalStorageUtils.setLocalStorageItem(this.unassignedOnlyVariable, isChecked);
    this.setState({ unassignedOnly: isChecked }, () => {
      this.populateKeywords();
    });
  }

  handleUserCheck(userChecked: any) {
    LocalStorageUtils.setLocalStorageItem(this.userOnlyVariable, userChecked);
    this.setState({ userOnly: userChecked }, () => {
      this.populateKeywords();
    });
  }

  handleDatesChanged(startDate: any, endDate: any) {
    if (startDate && endDate) {
      LocalStorageUtils.setLocalStorageItem(this.startDateVariable, startDate);
      LocalStorageUtils.setLocalStorageItem(this.endDateVariable, endDate);
      this.setState({ startDate, endDate }, () => {
        this.populateKeywords();
      });
    }
  }

  handleStatus = (rowData: KeywordQueueItem) => {
    this.rowData = rowData;
    this.id = rowData.id;
    this.setState({
      showCommentModal: true
    });
  };

  setIncludeDeleted = () => {
    LocalStorageUtils.setLocalStorageItem(
      this.includeDeletedReportsVariable,
      !this.state.includeDeleted
    );
    this.setState({ includeDeleted: !this.state.includeDeleted }, () => {
      this.populateKeywords();
    });
  };

  handleIncludeNewDriverReports(includeNew: any) {
    LocalStorageUtils.setLocalStorageItem(
      this.includeNewDriverReportsVariable,
      includeNew
    );
    this.setState(
      {
        includeNewDriverReports: includeNew
      },
      () => {
        this.populateKeywords();
      }
    );
  }
  closeModel = () => {
    this.setState({
      showCommentModal: false,
      pendingAction: "",
      comment: ""
    });
  };

  populateKeywords() {
    try {
      const uri = urls.SEARCH_KEYWORDS_PAGED;
      const persistentUserOnly = LocalStorageUtils.getLocalStorageBool(
        this.userOnlyVariable
      );
      const persistentAssignedOnly = LocalStorageUtils.getLocalStorageBool(
        this.assignedOnlyVariable
      );
      const persistentIncludeDeletedReports =
        LocalStorageUtils.getLocalStorageBool(
          this.includeDeletedReportsVariable
        );
      const persistentIncludeNewDriverReports =
        LocalStorageUtils.getLocalStorageBool(
          this.includeNewDriverReportsVariable
        );
      const persistentStartDate = LocalStorageUtils.getLocalStorageDate(
        this.startDateVariable
      );
      const persistentEndDate = LocalStorageUtils.getLocalStorageDate(
        this.endDateVariable
      );
      const persistentUnassignedOnly = LocalStorageUtils.getLocalStorageBool(
        this.unassignedOnlyVariable
      );
      const request: SearchKeywordQueuePagedRequest = {
        ...this.state.pagingCriteria,
        userOnly: persistentUserOnly ? persistentUserOnly : false,
        assignedOnly: persistentAssignedOnly ? persistentAssignedOnly : false,
        startDate: persistentStartDate
          ? persistentStartDate.toDate().toUTCString()
          : this.state.startDate.toDate().toUTCString(),
        endDate: persistentEndDate
          ? persistentEndDate.toDate().toUTCString()
          : this.state.endDate.toDate().toUTCString(),
        includeInactive: persistentIncludeDeletedReports
          ? persistentIncludeDeletedReports
          : false,
        includeNewDriverReports: persistentIncludeNewDriverReports
          ? persistentIncludeNewDriverReports
          : false,
        unassignedOnly: persistentUnassignedOnly
          ? persistentUnassignedOnly
          : false,
      };

      this.props.searchKeywordsPaged(uri, request);
    } catch (ex) {
      console.log(ex);
    }
  }

  getExportData = async (): Promise<KeywordQueueItem[]> => {
    const uri = urls.SEARCH_KEYWORDS_PAGED;
    const persistentUserOnly = LocalStorageUtils.getLocalStorageBool(
      this.userOnlyVariable
    );
    const persistentAssignedOnly = LocalStorageUtils.getLocalStorageBool(
      this.assignedOnlyVariable
    );
    const persistentIncludeDeletedReports =
      LocalStorageUtils.getLocalStorageBool(this.includeDeletedReportsVariable);
    const persistentIncludeNewDriverReports =
      LocalStorageUtils.getLocalStorageBool(
        this.includeNewDriverReportsVariable
      );
    const persistentStartDate = LocalStorageUtils.getLocalStorageDate(
      this.startDateVariable
    );
    const persistentEndDate = LocalStorageUtils.getLocalStorageDate(
      this.endDateVariable
    );
    const persistentUnassignedOnly = LocalStorageUtils.getLocalStorageBool(
      this.unassignedOnlyVariable
    );

    const request: SearchKeywordQueuePagedRequest = {
      ...this.state.pagingCriteria,
      itemsPerPage: this.props.totalKeywordQueueItems,
      pageNumber: 1,
      userOnly: persistentUserOnly ? persistentUserOnly : false,
      assignedOnly: persistentAssignedOnly ? persistentAssignedOnly : false,
      startDate: persistentStartDate
        ? persistentStartDate.toDate().toUTCString()
        : this.state.startDate.toDate().toUTCString(),
      endDate: persistentEndDate
        ? persistentEndDate.toDate().toUTCString()
        : this.state.endDate.toDate().toUTCString(),
      includeInactive: persistentIncludeDeletedReports
        ? persistentIncludeDeletedReports
        : false,
      includeNewDriverReports: persistentIncludeNewDriverReports
        ? persistentIncludeNewDriverReports
        : false,
      unassignedOnly: persistentUnassignedOnly ? persistentUnassignedOnly : false,
    };

    const response = await getKeywordQueueItems(uri, request);

    if (response.ok) {
      return response.data?.queueItems || [];
    }
    return [];
  };

  handleViewReportPDF(rowData: KeywordQueueItem) {
    this.props.loadImage(rowData.documentId, true);
  }

  handleAssignAndOpen(rowData: KeywordQueueItem) {
    let uri = GetURIByParts(
      this.props.webServiceURL,
      this.workflowController,
      ServiceEndPoints.AssignWorkflowItemStep
    );
    this.props.loadImage(rowData.documentId, true).then();

    if (rowData.assignedToUserId == this.props.currentUser.id) {
      this.props.openReportById(rowData.id, () => {
        this.props.history.push("/Keywords");
      });
    } else {
      this.props.assignAndOpen(uri, rowData.id, null).then(() => {
        this.props.history.push("/Keywords");
      });
    }
  }

  handleUnAssign(rowData: KeywordQueueItem) {
    console.log(rowData);
    let uri = GetURIByParts(
      this.props.webServiceURL,
      this.workflowController,
      ServiceEndPoints.UnAssignWorkflowItemStep
    );
    this.props.unAssign(uri, rowData).then(() => {
      //console.log('unassigned');
    });
  }

  handleDelete = async (
    event: React.MouseEvent<HTMLElement>,
    rowData: KeywordQueueItem
  ) => {
    this.setState({ showCommentModal: true });
    this.createManagementLog();
  };

  saveComment = () => {
    this.setDeleteStatus(this.id, this.rowData);
    this.createManagementLog();
    this.closeModel();
  };

  cancelComment = () => {
    this.setState({
      comment: "",
      showCommentModal: false
    });
  };

  onUpdateActiveStatus = (active: any) => {
    if (active) {
      this.setState({
        pendingAction: "deleteReport",
        showCommentModal: true
      });
      this.pendingAction = "deleteReport";
    } else {
      this.setState({
        pendingAction: "undeleteReport",
        showCommentModal: true
      });
      this.pendingAction = "undeleteReport";
    }
  };

setDeleteStatus = (id: number, rowData: KeywordQueueItem) => {

  if (rowData.reportStatusId == 6) {
    this.props.unDeleteReport(urls.UNDELETE_REPORT_FROM_KEYWORDS, rowData.id);
  } else {
    this.props.deleteReport(urls.DELETE_REPORT_FROM_KEYWORDS, rowData.id, this.state.comment)
      .then(x => {       
          this.populateKeywords();
      })
      .catch(err => {
          this.populateKeywords();
      });
  }
};

  updateActiveStatus = (
    paperReportId: number,
    crashReportId: number,
    active: boolean
  ): Promise<any> => {
    return Api.post(urls.SET_ACTIVE_STATUS, {
      paperReportId: paperReportId,
      crashReportId: crashReportId,
      active: active
    }).then((response: ApiResponse<any>) => {
      if (response.ok) {
        if (response.data.success) {// == "Report successfully deleted") {
          toast.info(response.data.desc);
          this.populateKeywords();
        } else if (response.data.success === false){ // == "Error - No reports modified") {
          toast.error(response.data.desc);
          console.log(response);
        }
      } else toast.warn("Service failed to connect");
      // @ts-ignore
    });
  };

  createManagementLog = () => {
    const newManagementLog: IAuditLogBase = {
      elasticIndex: ElasticIndices.Administration,
      logCategory: LogCategoryEnum.StatusChange,
      logLevel: LoggingLevel.Audit
    };

    const logData = {
      action: this.pendingAction,
      userComment: this.state.comment,
      reportId: this.reportIdValue
    };

    this.props.createManagementAuditLog(newManagementLog, logData);
  };

  handleChange = (e: React.FormEvent) => {
    let el: HTMLFormElement = e.currentTarget as HTMLFormElement;

    switch (el.dataset.field) {
      case "comment":
        this.setState({
          comment: el.value
        });
        break;
      default:
        break;
    }
  };

  handleClearDateSelection = (): void => {
    LocalStorageUtils.removeLocalStorageItem(this.startDateVariable);
    LocalStorageUtils.removeLocalStorageItem(this.endDateVariable);
    this.setState(
      { startDate: moment(QueueStartDate), endDate: moment() },
      () => {
        this.populateKeywords();
      }
    );
  };

  handlePagingCriteriaChange = (pagingCriteria: PagedResultsRequest) => {
    this.setState({ pagingCriteria: pagingCriteria as any }, () => {
      this.populateKeywords();
    });
  };

  columns: TableColumn<KeywordQueueItem>[] = [
    {
      name: "AVAILABLE ACTIONS",
      selector: (row) => row?.id,
      sortField: "Id",
      sortable: true,
      wrap: true,
      format: (row: KeywordQueueItem) => {
        return (
          <div className="buttonColumn">
            <Button
              variant="outline-primary"
              style={{ margin: 2 }}
              size="sm"
              onClick={() => this.handleViewReportPDF(row)}
            >
              View
            </Button>{" "}
            {(row.assignedToUserId == null ||
              row.assignedToUserId == this.props.currentUser.id) && (
                <Button
                  variant="outline-primary"
                  size="sm"
                  style={{ margin: 2 }}
                  onClick={() => this.handleAssignAndOpen(row)}
                >
                  {row.assignedToUserId == this.props.currentUser.id
                    ? "Continue"
                    : "Start"}
                </Button>
              )}{" "}
            {row.assignedToUserId != null && (
              <Button
                variant="outline-danger"
                size="sm"
                style={{ margin: 2 }}
                onClick={() => this.handleUnAssign(row)}
              >
                Unassign
              </Button>
            )}{" "}
            {row.reportStatusId != 6 && (
            <Button
              variant="outline-danger"
              style={{ margin: 2 }}
              size="sm"
              onClick={() => this.handleStatus(row)}
            >{"Delete"}</Button>
            )}
          </div>
        );
      }
    },
    {
      name: "DATE CREATED",
      sortable: true,
      sortField: "CreatedDate",
      wrap: true,
      selector: (row) =>
        row?.createdDate
          ? moment(row.createdDate).format("MM/DD/YYYY")
          : ""
    },
    {
      name: "DOCUMENT ID",
      sortField: "DocumentId",
      wrap: true,
      selector: (row) => row?.documentId || "",
      sortable: true
    },
    {
      name: "ASSIGNED TO",
      sortField: "AssignedToUserName",
      wrap: true,
      selector: (row) => (row?.assignedToUserName || "").split("@")[0],
      sortable: true
    },
    {
      name: "AGENCY",
      sortField: "AgencyName",
      wrap: true,
      selector: (row) => row?.agencyName || "",
      sortable: true
    },
    {
      name: "WORKFLOW STATUS",
      sortField: "WorkflowStatus",
      wrap: true,
      selector: (row) => row?.workflowStatus || "Status Indeterminable",
      sortable: true
    },
    {
      name: "PRIORITY",
      sortField: "OnBasePriorityNumber",
      wrap: true,
      selector: (row) => row?.priority || "",
      sortable: true
    }
  ];

  exportColumnMaps: IExportColumnMap[] = [
    { columnName: "ID", propertyName: "id" },
    {
      columnName: "DATE CREATED",
      propertyName: "createdDate",
      convertMethod: (val) => moment(val).format("MM/DD/YYYY hh:mma")
    },
    { columnName: "DOCUMENT ID", propertyName: "documentId" },
    { columnName: "ASSIGNED TO", propertyName: "assignedToUserName" },
    { columnName: "AGENCY", propertyName: "agencyName" },
    { columnName: "WORKFLOW STATUS", propertyName: "workflowStatus" },
    { columnName: "PRIORITY", propertyName: "priority" }
  ];

  public render() {
    return (
      <div className="app keywordqueue">
        <div className="row">
          <div className="col-sm-6">
            <h3>Keywords</h3>
          </div>
        </div>

        <hr />
        <Form>
          <Form.Row>
            <Form.Group as={Col} controlId="keywordQueueStartDate">
              <Form.Label>Created Date</Form.Label>
              <br />
              <DateRangePicker
                startDate={
                  LocalStorageUtils.getLocalStorageDate(
                    this.startDateVariable
                  ) || this.state.startDate
                } // momentPropTypes.momentObj or null,
                startDateId="keywordQueueStartDate" // PropTypes.string.isRequired,
                endDate={
                  LocalStorageUtils.getLocalStorageDate(this.endDateVariable) ||
                  this.state.endDate
                } // momentPropTypes.momentObj or null,
                endDateId="keywordQueueEndDate" // PropTypes.string.isRequired,
                onDatesChange={({ startDate, endDate }) =>
                  this.handleDatesChanged(startDate, endDate)
                } // PropTypes.func.isRequired,
                focusedInput={this.state.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                onFocusChange={(focusedInput) =>
                  this.setState({ focusedInput })
                } // PropTypes.func.isRequired,
                isOutsideRange={() => false}
                small={true}
                block={false}
                minimumNights={0}
              />
              {(LocalStorageUtils.getLocalStorageDate(this.startDateVariable) ||
                LocalStorageUtils.getLocalStorageDate(
                  this.endDateVariable
                )) && (
                  <button
                    className="btn btn-outline-danger btn-sm"
                    style={{ fontSize: "14px", marginLeft: "5px" }}
                    title="Clear Date Filter"
                    onClick={this.handleClearDateSelection}
                  >
                    <i className="fa fa-calendar-xmark" />
                  </button>
                )}
            </Form.Group>
            <Form.Group controlId="includeDeletedCheckbox">
              <Form.Check
                type="checkbox"
                checked={LocalStorageUtils.getLocalStorageBool(
                  this.includeDeletedReportsVariable
                )}
                onChange={this.setIncludeDeleted}
                label="Include Deleted Reports"
              />
            </Form.Group>
            &nbsp;&nbsp;&nbsp;
            <Form.Group controlId="assignedOnlyCheckbox">
              <Form.Check
                type="checkbox"
                label=" Show only Assigned"
                checked={LocalStorageUtils.getLocalStorageBool(
                  this.assignedOnlyVariable
                )}
                onChange={(e) => this.handleAssignedOnlyCheck(e.target.checked)}
              />
            </Form.Group>
            &nbsp;&nbsp;&nbsp;
            <Form.Group controlId="unassignedOnlyCheckbox">
              <Form.Check
                type="checkbox"
                label=" Show only Unassigned"
                checked={LocalStorageUtils.getLocalStorageBool(
                  this.unassignedOnlyVariable
                )}
                onChange={(e) => this.handleUnassignedOnlyCheck(e.target.checked)}
              />
            </Form.Group>
            &nbsp;&nbsp;&nbsp;
            <Form.Group controlId="AssignedMe">
              <Form.Check
                type="checkbox"
                label=" Show only Assigned to Me"
                checked={LocalStorageUtils.getLocalStorageBool(
                  this.userOnlyVariable
                )}
                onChange={(e) => this.handleUserCheck(e.target.checked)}
              />
            </Form.Group>
            &nbsp;&nbsp;&nbsp;
            <Form.Group controlId="NewDriver">
              <Form.Check
                type="checkbox"
                label=" Held Driver Reports"
                checked={LocalStorageUtils.getLocalStorageBool(
                  this.includeNewDriverReportsVariable
                )}
                onChange={(e) =>
                  this.handleIncludeNewDriverReports(e.target.checked)
                }
              />
            </Form.Group>
          </Form.Row>
          <Form.Row />
        </Form>
        {this.props.keywordQueueItems && (
          <div>
            <PagedDatatable
              columns={this.columns}
              data={this.props.keywordQueueItems || []}
              loadingData={this.props.loadingQueueItems}
              totalDataItems={this.props.totalKeywordQueueItems}
              exportTitle="Keyword Queue"
              exportFileName="KeywordQueue"
              exportColumnMaps={this.exportColumnMaps}
              pagingCriteria={this.state.pagingCriteria}
              updatePagedResults={this.handlePagingCriteriaChange}
              getExportData={this.getExportData}
            ></PagedDatatable>
          </div>
        )}
        <CommentModal
          comment={this.state.comment}
          show={this.state.showCommentModal}
          onCommentChange={this.handleChange}
          onCloseCommentModal={this.cancelComment}
          onCancel={this.cancelComment}
          onSave={this.saveComment}
        />
      </div>
    );
  }
}

export function mapStateToProps(state: any) {
  return {
    keywordQueueItems: state.Keywords.keywordQueueItems,
    totalKeywordQueueItems: state.Keywords.totalKeywordQueueItems,
    loadingQueueItems: state.Keywords.loadingQueueItems,
    webServiceURL: state.Application.backendURL,
    currentUser: state.Application.currentUser
  };
}

const mapDispatchToProps = {
  searchKeywordsPaged,
  openReportById,
  assignAndOpen,
  unAssign,
  loadImage,
  createManagementAuditLog,
  deleteReport,
  unDeleteReport,
  setLoadingQueueItems
};

export default connect(mapStateToProps, mapDispatchToProps)(KeywordQueuePaged);
